module.exports = __webpack_public_path__ + "img/BG.67b7f2c1.png";